import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { Tabs } from "@volca/ui/components/ui/tabs";
import { BusinessSettingsSidebarHeaderSkeleton } from "@/business-settings/common/business-settings-sidebar-header-skeleton";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const ReviewsSidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <BusinessSettingsSidebarHeaderSkeleton />
    <Stack align="start" gap={4} className="w-full flex-none px-6 pt-4">
      <Skeleton className="h-10 w-full"></Skeleton>
    </Stack>
    <div className="flex-1 overflow-hidden">
      <Stack align="start" gap={0} className="h-full w-full">
        <Tabs className="flex w-full flex-1 flex-col gap-4 overflow-hidden p-4 px-6">
          <Stack className="w-full" align="start" gap={2}>
            <Skeleton className="h-4 w-16"></Skeleton>
            <Skeleton className="h-5 w-40"></Skeleton>
          </Stack>

          <Stack className="w-full" align="start" gap={2}>
            <Skeleton className="h-4 w-16"></Skeleton>
            <Skeleton className="h-5 w-40"></Skeleton>
          </Stack>

          <Stack className="w-full" align="start" gap={2}>
            <Skeleton className="h-4 w-16"></Skeleton>
            <Skeleton className="h-5 w-40"></Skeleton>
          </Stack>
        </Tabs>
      </Stack>
    </div>
  </BusinessSettingsSidebarWrapper>
);
